import type { TContact } from '~/types/contact/models'

/**
 * Contacts split by whom each belongs to: company contacts, then supplier
 * contacts, then TSD contacts. For a picker that shows an unscoped contact
 * list in groups -- Send Email's To / cc / bcc on a case or service request
 * that names nothing to scope by. Order within a group is kept; groups may be
 * empty.
 *
 * ⚠ Lead-source contacts are LEFT OUT, deliberately: nobody emails a lead
 * source from a case or service request.
 */
export function groupContactsByParent(contacts: TContact[]): TContact[][] {
  return [
    contacts.filter((c) => c.company),
    contacts.filter((c) => !c.company && c.supplier),
    contacts.filter((c) => !c.company && !c.supplier && c.tsd),
  ]
}
